export default "__VITE_PUBLIC_ASSET__9d04e3fc__"